import { CSSObject } from '@emotion/react'
import { Color, Size, Spacing, Theme, Transition } from '@opallabs/gem'

export const container: CSSObject = {
  borderRadius: Spacing.S * 2,

  ...Transition(['border', 'background-color', 'gap']),

  '& > input, & > span.clear-icon-container': {
    ...Transition(['inline-size']),
  },

  '& button': {
    borderRadius: Spacing.S * 2,
  },
}

export const collapsed: CSSObject = {
  gap: 0,
  border: '1px solid transparent',
  backgroundColor: 'transparent',

  '& > input, & > span.clear-icon-container': {
    inlineSize: 0,
    minInlineSize: 0,
  },
}

/** The squared search of the Web Components file: Surface 2 under a hairline. */
export const square = (theme: Theme): CSSObject => ({
  backgroundColor: Color[theme]['Color/Surface/Surface-2'],
  borderColor: Color[theme]['Strokes/Secondary-2'],
  borderRadius: Size.Rounding,

  '& button': {
    borderRadius: Size.Rounding,
  },
})
